export type EvidenceOriginFields = {
  cxItem?: { trueOrigin?: string; origin?: string } | null;
  opportunity?: { trueOrigin?: string; origin?: string } | null;
  trueOrigin?: string;
  origin?: string;
};

/**
 * Logo + origin label resolution (consistent everywhere):
 * cxItem.trueOrigin → cxItem.origin → evidence.trueOrigin → evidence.origin → opportunity fallbacks.
 */
export function resolveEvidenceDisplayOrigin(
  evidence: EvidenceOriginFields | null | undefined
): string | undefined {
  if (!evidence) return undefined;
  const cx = evidence.cxItem;
  const opp = evidence.opportunity;
  return (
    cx?.trueOrigin ||
    cx?.origin ||
    evidence.trueOrigin ||
    evidence.origin ||
    opp?.trueOrigin ||
    opp?.origin
  );
}
